/**
 * Keeps homepage sections in sync with locale files.
 * Shopify full-page HTML cache can serve stale section markup; the Sections
 * Rendering API always returns fresh Liquid output (same source as nav/footer | t).
 */
(function () {
  var TEMPLATE_SUFFIX = '29153719714056';
  var DEFAULT_SECTIONS = [
    'surfstr_hero_h1',
    'surfstr_banner_i18n',
    'surfstr_benefits_i18n',
    'surfstr_shipping',
    'surfstr_band_efficiency',
    'surfstr_video_reviews',
    'surfstr_final_cta_home',
    'surfstr_faq_home',
  ];

  var TARGETS = {
    surfstr_hero_h1: { root: '.surfstr-lovable-hero' },
    surfstr_banner_i18n: { root: '.surfstr-scroll-text' },
    surfstr_benefits_i18n: { root: '.surfstr-benefits__inner' },
    surfstr_shipping: { root: '.surfstr-shipping__inner' },
    surfstr_band_efficiency: { root: '.surfstr-band__inner' },
    surfstr_video_reviews: {
      partial: ['.surfstr-video-reviews__marquee', '.surfstr-video-reviews__intro'],
    },
    surfstr_final_cta_home: { root: '.surfstr-final-cta__inner' },
    surfstr_faq_home: { root: '.surfstr-faq' },
  };

  function getShortSectionKeys() {
    var meta = document.querySelector('meta[name="surfstr-home-i18n-sections"]');
    if (!meta || !meta.content) return DEFAULT_SECTIONS;
    return meta.content
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function getTemplateSuffix() {
    // Derive from the rendered DOM first so the sync works on any theme
    // instance (section containers are id="shopify-section-template--<id>__<key>").
    var sectionNode = document.querySelector('[id^="shopify-section-template--"]');
    if (sectionNode && sectionNode.id) {
      var match = sectionNode.id.match(/^shopify-section-template--(.+?)__/);
      if (match) return match[1];
    }
    var meta = document.querySelector('meta[name="surfstr-home-i18n-template"]');
    if (meta && meta.content) return meta.content.trim();
    return TEMPLATE_SUFFIX;
  }

  function toFullSectionKey(shortKey) {
    return 'template--' + getTemplateSuffix() + '__' + shortKey;
  }

  function shouldSync() {
    return document.body && document.body.classList.contains('surfstr-lovable-layout');
  }

  // Sections carry live JS state (fitted hero clips, keyed canvases, map viewBox, FAQ toggle listeners).
  // Only swap markup when the copy really differs, and re-run the section's inline scripts when we do.
  function sameText(a, b) {
    var norm = function (node) { return (node.textContent || '').replace(/\s+/g, ' ').trim(); };
    return norm(a) === norm(b);
  }

  function rerunScripts(parsedDoc) {
    var scripts = parsedDoc.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++) {
      var s = document.createElement('script');
      s.textContent = scripts[i].textContent;
      document.body.appendChild(s);
      s.remove();
    }
  }

  function applyPartialHtml(selectors, parsedDoc) {
    var changed = false;
    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i];
      var freshNode = parsedDoc.querySelector(selector);
      var liveNode = document.querySelector(selector);
      if (!freshNode || !liveNode || sameText(freshNode, liveNode)) continue;
      liveNode.innerHTML = freshNode.innerHTML;
      changed = true;
    }
    return changed;
  }

  function applySectionHtml(sectionKey, html) {
    var target = TARGETS[sectionKey];
    if (!target || !html) return;

    var parsed = new DOMParser().parseFromString(html, 'text/html');

    if (target.partial && target.partial.length) {
      if (applyPartialHtml(target.partial, parsed)) rerunScripts(parsed);
      return;
    }

    var selector = target.root;
    if (!selector) return;

    var freshRoot =
      parsed.querySelector(selector) ||
      parsed.querySelector('.shopify-section') ||
      parsed.body.firstElementChild;
    var liveRoot = document.querySelector(selector);

    if (!freshRoot || !liveRoot || sameText(freshRoot, liveRoot)) return;
    liveRoot.innerHTML = freshRoot.innerHTML;
    rerunScripts(parsed);

    if (sectionKey === 'surfstr_hero_h1') {
      document.querySelectorAll('[aria-labelledby^="surfstr-hero-title-"]').forEach(function (node) {
        var title = document.querySelector('.surfstr-lovable-hero__title');
        if (title && title.id) node.setAttribute('aria-labelledby', title.id);
      });
    }
  }

  function syncHomeSections() {
    if (!shouldSync()) return;

    var shortKeys = getShortSectionKeys();
    if (!shortKeys.length) return;

    var fullKeys = shortKeys.map(toFullSectionKey);

    // The Section Rendering API answers 400 once the `sections` list passes five ids, so request in chunks.
    var CHUNK = 5;
    var chunks = [];
    for (var c = 0; c < shortKeys.length; c += CHUNK) chunks.push(shortKeys.slice(c, c + CHUNK));

    Promise.all(
      chunks.map(function (chunk) {
        var url = new URL(window.location.href);
        url.searchParams.set('sections', chunk.map(toFullSectionKey).join(','));
        url.searchParams.set('surfstr_home_i18n', String(Date.now()));
        return fetch(url.toString(), {
          headers: { Accept: 'application/json', 'X-Requested-With': 'SurfstrHomeI18nSync' },
          credentials: 'omit',
        })
          .then(function (response) {
            if (!response.ok) throw new Error('sections fetch failed');
            return response.json();
          })
          .catch(function () {
            return {}; /* keep server-rendered markup for this chunk */
          });
      })
    ).then(function (payloads) {
      var payload = {};
      payloads.forEach(function (part) {
        for (var k in part) if (Object.prototype.hasOwnProperty.call(part, k)) payload[k] = part[k];
      });
      for (var i = 0; i < shortKeys.length; i++) {
        var shortKey = shortKeys[i];
        var fullKey = fullKeys[i];
        var html = payload[fullKey] || payload[shortKey];
        if (html) applySectionHtml(shortKey, html);
      }
      document.documentElement.setAttribute('data-surfstr-home-i18n-synced', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHomeSections, { once: true });
  } else {
    syncHomeSections();
  }
})();
